import type { ReactElement, ReactNode } from 'react'

import BlockTitle from '~/components/Blocks/Title'
import GridItemLayout from '~/components/GridItemLayout'
import Variation from '~/components/Variation'

import './styles.scss'

interface Props {
  title: ReactNode
  value: number
}

const CurrentVsStartBlock = ({ title, value }: Props): ReactElement => {
  return (
    <GridItemLayout className="currentvsstart-block-component">
      <BlockTitle className="currentvsstart-block-component__title">{title}</BlockTitle>
      <div className="currentvsstart-wrapper ">
        <Variation direction={value < 0 ? 'down' : 'up'} value={value * 100} />
      </div>
    </GridItemLayout>
  )
}

export default CurrentVsStartBlock
